"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CharTypesEnum_1 = require("../constants/CharTypesEnum");

var copyMaskChar = function (count, maskChar) {
  var res = [];

  for (var i = 0; i < count; i++) {
    res.push({
      char: maskChar,
      type: CharTypesEnum_1.CharTypes.MASK
    });
  }

  return res;
};

var pasteMaskSymbols = function (maskString, maskChar, selection) {
  if (maskString) {
    var res = [];

    for (var i = selection.start; i < selection.end; i++) {
      res.push({
        char: maskString[i],
        type: CharTypesEnum_1.CharTypes.MASK
      });
    }

    return res;
  }

  return copyMaskChar(selection.end - selection.start, maskChar);
};

function removeSelectedRange(param) {
  var value = param.value,
      selection = param.selection,
      maskChar = param.maskChar,
      maskString = param.maskString;

  if (selection.end < selection.start) {
    var tmp = selection.end;
    selection.end = selection.start;
    selection.start = tmp;
  }

  if (selection.start === selection.end) {
    return value;
  }

  if (value.length > selection.start) {
    return value.slice(0, selection.start).concat(pasteMaskSymbols(maskString, maskChar, selection), value.slice(selection.end, value.length));
  }

  return value;
}

exports.default = removeSelectedRange;